module.exports = __webpack_public_path__ + "02_short_gold.ce65a385.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_short_gold.png
// module id = Cb53
// module chunks = 0